export const SwitchSchemaConstants = {
  //TTClub
  1: {
    lights: [
      {
        width: '50%',
        height: '11%',
        top: '9%',
        left: '75%',
        switchStyles: { top: '76%', leftSm: '40%', leftMd: '45%', leftLg: '47%' },
      },
      {
        width: '50%',
        height: '11%',
        top: '23%',
        left: '75%',
        switchStyles: { top: '76%', leftSm: '40%', leftMd: '45%', leftLg: '47%' },
      },
      {
        width: '50%',
        height: '11%',
        top: '42%',
        left: '75%',
        switchStyles: { top: '76%', leftSm: '40%', leftMd: '45%', leftLg: '47%' },
      },
      {
        width: '50%',
        height: '11%',
        top: '88%',
        left: '75%',
        switchStyles: { top: '76%', leftSm: '40%', leftMd: '45%', leftLg: '47%' },
      },
      {
        width: '50%',
        height: '11%',
        top: '88%',
        left: '21%',
        switchStyles: { top: '76%', leftSm: '40%', leftMd: '45%', leftLg: '47%' },
      },
      {
        width: '50%',
        height: '11%',
        top: '11%',
        left: '24%',
        switchStyles: { top: '76%', leftSm: '40%', leftMd: '45%', leftLg: '47%' },
      },
    ],
    doors: [
      {
        width: '7%',
        height: '10%',
        top: '48%',
        left: '51%',
        doorStyles: { topSm: '43%', topLg: '45%', leftSm: '0%', leftMd: '0%', leftLg: '27%' },
      },
      {
        width: '7%',
        height: '10%',
        top: '57%',
        left: '51%',
        doorStyles: { topSm: '43%', topLg: '45%', leftSm: '0%', leftMd: '0%', leftLg: '27%' },
      },
    ],
  },
  //Delovaya
  2: {
    lights: [
      {
        width: '50%',
        height: '50%',
        top: '75%',
        left: '68%',
        switchStyles: { top: '76%', leftSm: '40%', leftMd: '45%', leftLg: '47%' },
      },
      {
        width: '50%',
        height: '50%',
        top: '75%',
        left: '25%',
        switchStyles: { top: '76%', leftSm: '40%', leftMd: '45%', leftLg: '47%' },
      },
      {
        width: '50%',
        height: '50%',
        top: '28%',
        left: '68%',
        switchStyles: { top: '76%', leftSm: '40%', leftMd: '45%', leftLg: '47%' },
      },
      {
        width: '50%',
        height: '50%',
        top: '28%',
        left: '25%',
        switchStyles: { top: '76%', leftSm: '40%', leftMd: '45%', leftLg: '47%' },
      },
    ],
    doors: [
      {
        width: '7%',
        height: '100%',
        top: '0%',
        left: '93%',
        doorStyles: { topSm: '43%', topLg: '45%', leftSm: '0%', leftMd: '0%', leftLg: '27%' },
      },
    ],
  },
};
